import { resolveV3 } from '@/endpoints/resolveV3';
import DataResponse from '@/endpoints/types';

import { SavedSelection } from '../../../../models/land';

export async function getPublicSavedSelection(
  id: string | number,
  signal?: AbortSignal,
  timeout: number | undefined = undefined
): Promise<DataResponse<SavedSelection>> {
  const data = await resolveV3(
    {
      signal,
      timeout,
      url: `/saved_selections/public/${id}/`,
    },
    {
      baseUrl: 'itasca',
    }
  );

  return data;
}
